import { render, staticRenderFns } from "./Carcass.vue?vue&type=template&id=e4b6ce88&lang=pug&"
import script from "./Carcass.vue?vue&type=script&lang=js&"
export * from "./Carcass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports